export default __webpack_public_path__ + "static/media/login.59c0e976.svg";